import { SvgChevrondown } from '@common/icon';
import { cn } from '@core/utils';
import { memo } from 'react';

interface AccordionProps {
  item: {
    id: string;
    question: string;
    answer: string;
  };
  isOpen: boolean;
  onToggle: () => void;
}

export const Accordion = memo(({ item, isOpen, onToggle }: AccordionProps) => {
  const headerId = `faq-header-${item.id}`;
  const panelId = `faq-panel-${item.id}`;

  return (
    <div className="w-full border-b border-Gray-800 last:border-b-0">
      <h4 className="m-0">
        <button
          type="button"
          onClick={onToggle}
          className="flex w-full items-center justify-between py-12 text-left font-500 text-Gray-300 transition-opacity duration-200 typo-body4 hover:opacity-80"
          aria-expanded={isOpen}
          aria-controls={panelId}
          id={headerId}
        >
          <span className="flex-1 pr-8">{item.question}</span>
          <SvgChevrondown
            className={cn(
              'size-16 shrink-0 text-Gray-300 transition-transform duration-300',
              isOpen && 'rotate-180',
            )}
            aria-hidden="true"
          />
        </button>
      </h4>
      <div
        id={panelId}
        role="region"
        aria-labelledby={headerId}
        className={cn(
          'grid transition-[grid-template-rows] duration-300',
          isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
        )}
      >
        <div className="overflow-hidden">
          <p className="m-0 whitespace-pre-wrap pb-12 font-400 leading-normal text-Gray-550 typo-body4">
            {item.answer}
          </p>
        </div>
      </div>
    </div>
  );
});

Accordion.displayName = 'Accordion';
